export interface Category {
  slug: string;
  name: string;
  short: string;
  desc: string;
  cover: string;
  icon: string;
}

export interface PostSection {
  heading: string;
  text: string;
}

export interface Post {
  id: string;
  title: string;
  categorySlug: string;
  excerpt: string;
  cover: string;
  date: string;
  views: number;
  readTime: string;
  author: string;
  tags: string[];
  highlights: string[];
  sections: PostSection[];
}

export const categories: Category[] = [
  {
    slug: 'variety',
    name: '综艺名场面',
    short: '综艺',
    desc: '舞台、露营、竞技、慢综，那些被反复回看的即兴瞬间与临场反应。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20collage%20inspired%20by%20variety%20show%20stage%20lights%20cradled%20in%20deep%20amber%20haze%2C%20glowing%20silhouettes%20of%20spotlights%20and%20confetti%2C%20abstract%20stylized%20editorial%20poster%20art%2C%20rich%20crimson%20and%20gold%20tones%2C%20high%20contrast%2C%20no%20text%2C%20no%20people%20faces&width=800&height=600&seq=gf-cat-variety&orientation=landscape',
    icon: 'ri-mic-2-line',
  },
  {
    slug: 'drama',
    name: '影视高能',
    short: '影视',
    desc: '大结局反转、雨夜对峙、群像配角，一句台词就能刷屏的高光时刻。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20still%20abstract%20art%20of%20a%20rainy%20night%20alley%20with%20warm%20lantern%20glow%2C%20dramatic%20shadows%20and%20reflective%20wet%20ground%2C%20deep%20crimson%20and%20amber%20palette%2C%20moody%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20visible%20faces&width=800&height=600&seq=gf-cat-drama&orientation=landscape',
    icon: 'ri-film-line',
  },
  {
    slug: 'awards',
    name: '颁奖礼爆点',
    short: '颁奖礼',
    desc: '红毯被风吹起的裙摆、领奖台上的一句真心话，被剪进正片与没被剪进的都在这。',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20stylized%20awards%20ceremony%20backdrop%20art%20with%20golden%20bokeh%20lights%2C%20red%20carpet%20ribbon%20shapes%20and%20warm%20spotlight%20beams%2C%20crimson%20and%20champagne%20gold%20palette%2C%20luxurious%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=gf-cat-awards&orientation=landscape',
    icon: 'ri-award-line',
  },
  {
    slug: 'sports',
    name: '体坛名场面',
    short: '体坛',
    desc: '压哨绝杀、最后一棒反超、老将谢幕，让人站起来的那几分钟。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20sports%20arena%20art%20with%20warm%20stadium%20floodlights%2C%20motion%20light%20trails%20and%20glowing%20scoreboard%20glow%2C%20energetic%20red%20orange%20and%20amber%20palette%2C%20dynamic%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=gf-cat-sports&orientation=landscape',
    icon: 'ri-basketball-line',
  },
  {
    slug: 'meme',
    name: '网络热梗',
    short: '热梗',
    desc: '从一句话到全网梗，表情包、弹幕与热词的诞生现场。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20stylized%20abstract%20art%20of%20floating%20rounded%20speech%20bubbles%20and%20meme%20card%20shapes%20in%20warm%20coral%20and%20butter%20yellow%2C%20soft%20playful%20energy%2C%20graphic%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=gf-cat-meme&orientation=landscape',
    icon: 'ri-emotion-happy-line',
  },
];

export const posts: Post[] = [
  {
    id: 'variety-01',
    title: '《星光舞台》年度总决赛：逆风翻盘的三分钟，全场起立鼓掌',
    categorySlug: 'variety',
    excerpt:
      '开票垫底、彩排受伤、临场改歌单，她却在最后三分钟把整季浓缩成一次高音。这一段被网友称为本季最想反复回看的名场面。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20stage%20scene%20with%20a%20solo%20spotlight%20on%20an%20empty%20performance%20platform%2C%20drifting%20golden%20confetti%20and%20deep%20crimson%20haze%2C%20stylized%20editorial%20poster%20art%2C%20rich%20amber%20and%20red%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20visible%20faces&width=1200&height=675&seq=gf-post-variety-01&orientation=landscape',
    date: '2026-08-28',
    views: 48210,
    readTime: '5 分钟',
    author: '看点编辑部',
    tags: ['综艺名场面', '舞台高能', '逆风翻盘'],
    highlights: [
      '开票排名垫底，赛前被普遍预测是"陪跑位"',
      '彩排时突发嗓子不适，临时把高音段落整整提前了八小节',
      '最后三分钟全场安静，再集体起立鼓掌',
    ],
    sections: [
      {
        heading: '从陪跑位到全场起立',
        text:
          '这一季《星光舞台》的总决赛在赛前几乎没有悬念。综合前几轮投票，她排在最末，连节目自己的预热通稿都把她写成"黑马候选人"而不是"夺冠热门"。可真正站上舞台的那一刻，所有预先写好的剧本都被推翻了。',
      },
      {
        heading: '临场改歌单的那八小节',
        text:
          '据现场工作人员回忆，彩排时她嗓子状态并不理想，原本设计在副歌之后的爆发高音被判断为"风险太高"。她没有降调，反而把整段高音提前了八小节，用一个更短的呼吸间隙硬顶上去。这个决定让整首歌的情绪曲线完全不同。',
      },
      {
        heading: '三分钟里的安静与掌声',
        text:
          '进入最后一段时，导播明显把现场的收音开大了。原本还在低声讨论的观众席突然安静下来，直到最后一个长音落下，掌声才像被延迟释放一样整齐地炸开。很多观众是在那一刻才意识到，自己看的不是一场比赛，而是一次纯粹的现场。',
      },
      {
        heading: '为什么这段会被反复回看',
        text:
          '它没有复杂的舞美，也没有夸张的剪辑，打动人的是那种"明知道很难还是要上"的直觉。对很多观众来说，这种不给自己留退路的瞬间，正是名场面之所以成立的原因。',
      },
    ],
  },
  {
    id: 'variety-02',
    title: '露营综艺名场面：一场暴雨里的即兴合唱，成了整季最高光',
    categorySlug: 'variety',
    excerpt:
      '设备进水、帐篷漏雨、录制被迫中断，六个人却围着快熄灭的炉火唱了整整二十分钟。这段没有台本的画面成了全季评分最高的一集。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20stylized%20night%20camping%20scene%20with%20a%20small%20glowing%20campfire%20under%20rain%2C%20tent%20silhouettes%20and%20soft%20amber%20light%2C%20cozy%20atmospheric%20editorial%20poster%20art%2C%20deep%20brown%20and%20orange%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-variety-02&orientation=landscape',
    date: '2026-08-21',
    views: 31540,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['慢综艺', '治愈名场面', '即兴合唱'],
    highlights: [
      '暴雨导致设备进水，录制一度宣布暂停',
      '六位嘉宾围着快熄灭的炉火即兴合唱二十分钟',
      '节目上线后成为全季评分最高的一集',
    ],
    sections: [
      {
        heading: '一场打乱所有计划的暴雨',
        text:
          '这档露营综艺原本走的是轻松路线，结果第三天就遇上了连夜的暴雨。收音设备、灯光和大部分备用电源都受了影响，导演组一度决定暂停录制，先保证大家的安全。',
      },
      {
        heading: '没有台本的二十分钟',
        text:
          '停电之后，几个人索性搬着折叠椅挤到唯一还亮着的炉火旁边。不知道是谁先起的头，一首很老的歌被断断续续地唱了出来。没有伴奏，跑调也没人纠正，中间还因为雨声太大反复重来。',
      },
      {
        heading: '为什么这段没有台词却最打动人',
        text:
          '节目播出后，这一段几乎没有剪掉任何停顿。观众说，正是那种"什么都没发生"的松弛感，让整季节目第一次显得真实。有时候名场面不是设计出来的高光，而是被意外留住的温度。',
      },
    ],
  },
  {
    id: 'variety-03',
    title: '慢综艺里的温柔瞬间：他把最后一块蛋糕留给了新人',
    categorySlug: 'variety',
    excerpt:
      '录制到深夜、蛋糕只剩一块，作为常驻前辈的他默默把它推给了刚加入的新人，全程一句话都没说。这个三秒镜头被剪进了花絮，却成了弹幕最多的一段。',
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20warm%20stylized%20still%20life%20of%20a%20single%20slice%20of%20cake%20on%20a%20wooden%20table%20under%20gentle%20night%20lamp%20light%2C%20cozy%20editorial%20poster%20art%2C%20cream%20beige%20and%20amber%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-variety-03&orientation=landscape',
    date: '2026-08-14',
    views: 19870,
    readTime: '3 分钟',
    author: '看点编辑部',
    tags: ['慢综艺', '温柔瞬间', '前辈新人'],
    highlights: [
      '录制到深夜，只剩最后一块蛋糕',
      '前辈一句话没说，直接把蛋糕推给新人',
      '三秒花絮镜头成为全期弹幕密度最高的一段',
    ],
    sections: [
      {
        heading: '一个几乎没人注意的小动作',
        text:
          '那期节目录制到很晚，收工前的加餐只剩最后一块蛋糕。镜头里的他只是顺手把盘子往旁边推了推，没有台词，甚至没有看对方一眼。如果不是节目组把它剪进花絮，可能没人会注意到。',
      },
      {
        heading: '弹幕为什么突然变多',
        text:
          '花絮上线后，这段三秒钟的画面成了全期弹幕密度最高的一段。观众说，比起刻意的照顾，这种"不需要被感谢"的体贴反而更动人。',
      },
      {
        heading: '温柔也是一种名场面',
        text:
          '我们整理名场面的时候，常常会优先记录爆发和反转。但这个片段提醒我们，安静地把东西让出去，同样是一种值得被记住的高光。',
      },
    ],
  },
  {
    id: 'drama-01',
    title: '《长夜行》大结局：一句话反转，弹幕刷屏整整三分钟',
    categorySlug: 'drama',
    excerpt:
      '全剧埋了二十多集的伏笔，在最后一句话里被一次性点破。没有大场面，只有一个回头的镜头，却让无数观众倒回去重看了三遍。',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20stylized%20cinematic%20art%20of%20a%20lone%20figure%20silhouette%20at%20the%20end%20of%20a%20long%20dark%20corridor%20with%20a%20warm%20door%20of%20light%2C%20deep%20crimson%20and%20amber%20palette%2C%20dramatic%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-drama-01&orientation=landscape',
    date: '2026-09-02',
    views: 64230,
    readTime: '5 分钟',
    author: '看点编辑部',
    tags: ['影视高能', '结局反转', '伏笔回收'],
    highlights: [
      '前二十多集埋下的细节在最后一句台词里全部回收',
      '没有大场面，靠一个回头镜头完成反转',
      '播出当晚相关词条冲上讨论榜前列',
    ],
    sections: [
      {
        heading: '反转不靠场面，靠一句台词',
        text:
          '《长夜行》的结局播出前，观众普遍以为会有一场正面冲突。结果全剧最后的高潮只是一个再普通不过的告别场景，真正的反转藏在人物转身之前说的那句轻描淡写的话里。',
      },
      {
        heading: '被回收的细节',
        text:
          '回过头看，第一集那道没关严的门、第七集被随手放下的钥匙、第十五集没接的那通电话，都在这句话里有了新的解释。编剧没有额外解释，而是把判断权完全交还给了观众。',
      },
      {
        heading: '观众的反应',
        text:
          '结局播出当晚，社交平台上出现了大量"倒回去重看"的帖子。很多人承认，第一次看时甚至没意识到那句话有问题，直到字幕滚动才发现自己被绕了二十多集。',
      },
    ],
  },
  {
    id: 'drama-02',
    title: '古装剧里最出圈的雨夜对峙，台词句句扎心',
    categorySlug: 'drama',
    excerpt:
      '没有配乐、没有慢镜头，两个人在雨里站了整整四分钟。这场戏后来被剪成无数个短视频片段，成为今年古装剧最有辨识度的画面之一。',
    cover:
      'https://readdy.ai/api/search-image?query=Dramatic%20stylized%20rain-soaked%20courtyard%20at%20night%20with%20warm%20lantern%20reflections%20on%20wet%20stone%2C%20deep%20shadows%20and%20crimson%20accents%2C%20cinematic%20editorial%20poster%20art%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-drama-02&orientation=landscape',
    date: '2026-08-30',
    views: 40980,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['古装剧', '雨夜戏', '台词高光'],
    highlights: [
      '全程没有配乐，只保留雨声与呼吸声',
      '四分钟长镜头，两位演员一条过',
      '被大量二创剪辑，成为年度画面之一',
    ],
    sections: [
      {
        heading: '敢把配乐拿掉的四分钟',
        text:
          '这场对峙戏最特别的地方，是导演几乎放弃了所有辅助手段。没有配乐推进，没有慢镜头强调，画面里能听见的只有雨声、脚步声和两个人在说话前的呼吸。',
      },
      {
        heading: '台词为什么被反复引用',
        text:
          '两位角色的每一句都没有直接说"恨"或"原谅"，而是用非常日常的细节在互相试探。观众说，正因为说得克制，才显得每一句都像刀子。',
      },
      {
        heading: '一条过的现场',
        text:
          '据演员采访透露，这场戏拍了整整一个雨夜，最后用的是第一条。原因很朴素——第一条里两个人真的都在发抖，那种生理层面的紧绷骗不了人。',
      },
    ],
  },
  {
    id: 'drama-03',
    title: '群像剧的高光配角：出场十分钟，被记住了整年',
    categorySlug: 'drama',
    excerpt:
      '她全剧只出现了十分钟，一句台词都没有，却靠着几个眼神成了观众讨论度最高的角色。好的配角，从来不需要靠戏份说话。',
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20stylized%20portrait-free%20cinematic%20art%20of%20a%20dim%20teahouse%20interior%20with%20warm%20hanging%20lamps%20and%20steam%2C%20nostalgic%20editorial%20poster%20texture%2C%20amber%20brown%20and%20crimson%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-drama-03&orientation=landscape',
    date: '2026-08-25',
    views: 27650,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['群像剧', '配角高光', '表演细节'],
    highlights: [
      '全剧出场不足十分钟，几乎没有台词',
      '靠几个递茶、停顿的动作完成人物弧光',
      '成为该剧讨论度最高的角色之一',
    ],
    sections: [
      {
        heading: '十分钟如何立住一个人物',
        text:
          '在群像剧里，配角往往只有寥寥几个镜头。这个角色第一次出现时只是递了一杯茶，第二次出现时手在抖，第三次出现时杯子已经换成了一次性的。三处细节，就把人物的处境交代清楚。',
      },
      {
        heading: '不需要台词的表演',
        text:
          '她的所有情绪变化都发生在台词之间的空隙里——一个停顿、一次移开视线、一次深呼吸。观众不需要被解释，就能感受到这个人物正在经历什么。',
      },
      {
        heading: '配角的意义',
        text:
          '很多观众说，正是因为这些不算主角的人物足够扎实，整部剧的世界才显得可信。有时候，一个好配角带来的说服力，不亚于一场主角的高光戏。',
      },
    ],
  },
  {
    id: 'awards-01',
    title: '年度盛典·最佳新人：领奖台上那句谢谢，让全场安静了两秒',
    categorySlug: 'awards',
    excerpt:
      '拿奖的人很多，但很少有人像她这样，把话筒对准了后台。那句感谢让原本热闹的颁奖礼突然安静下来，随后才是更长的掌声。',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20stylized%20awards%20stage%20art%20with%20a%20single%20golden%20microphone%20on%20an%20empty%20podium%20under%20warm%20spotlights%20and%20red%20curtain%20glow%2C%20luxurious%20editorial%20poster%20texture%2C%20crimson%20champagne%20gold%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-awards-01&orientation=landscape',
    date: '2026-09-05',
    views: 35420,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['颁奖礼', '获奖感言', '最佳新人'],
    highlights: [
      '获奖感言没有感谢团队，而是把话筒对准后台',
      '全场安静两秒后爆发更长的掌声',
      '被剪进正片，成为当晚传播最广的片段',
    ],
    sections: [
      {
        heading: '一句没有写进提词器的感谢',
        text:
          '按照惯例，新人奖的感言大多集中在感谢公司和团队。她上台后先是照常感谢，随后停了一下，把话筒转向了后台方向，念出了几个一直在幕后工作的名字。',
      },
      {
        heading: '安静的两秒',
        text:
          '现场导播后来透露，那两秒的安静并不是冷场，而是很多人没反应过来。紧接着掌声比之前任何一次都长，连前排几位前辈都站了起来。',
      },
      {
        heading: '为什么这段值得被记住',
        text:
          '颁奖礼的高光通常属于最闪耀的人，但这段画面把光打向了通常不会被镜头对准的地方。或许这就是它被反复转发的原因。',
      },
    ],
  },
  {
    id: 'awards-02',
    title: '红毯名场面盘点：被风吹起裙摆后，她的反应太圈粉',
    categorySlug: 'awards',
    excerpt:
      '红毯突遇大风，裙摆被整个掀起。她没有慌乱，而是先扶住了旁边工作人员手里的设备，再从容转身。这个细节让当晚的讨论从造型变成了态度。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20red%20carpet%20event%20art%20at%20dusk%20with%20flowing%20fabric%20ribbons%20and%20warm%20golden%20lights%2C%20elegant%20editorial%20poster%20texture%2C%20crimson%20and%20champagne%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-awards-02&orientation=landscape',
    date: '2026-08-18',
    views: 22980,
    readTime: '3 分钟',
    author: '看点编辑部',
    tags: ['红毯', '临场反应', '名场面盘点'],
    highlights: [
      '红毯突遇大风，裙摆被掀起',
      '第一时间伸手扶住旁边工作人员的设备',
      '当晚讨论焦点从造型转向临场反应',
    ],
    sections: [
      {
        heading: '三秒之内的两个动作',
        text:
          '大风来得毫无预兆。画面里，她的第一反应不是去按裙摆，而是先伸手扶了一下旁边摇摇欲坠的摄影设备，确认对方站稳之后，才不紧不慢地转身整理造型。',
      },
      {
        heading: '为什么大家记住了这个顺序',
        text:
          '红毯上的意外每年都有，但观众这次的讨论点很集中：在镜头对准自己的时候，先照顾别人的那个顺序。很多人说，这比任何造型都更能说明问题。',
      },
      {
        heading: '红毯名场面的另一种写法',
        text:
          '我们习惯把红毯名场面定义为"惊艳"，但这一次，它记录的是一个人在突发状况下的本能选择。这同样值得被放进年度盘点里。',
      },
    ],
  },
  {
    id: 'sports-01',
    title: '全明星赛最后一攻：0.8 秒压哨三分，解说喊到破音',
    categorySlug: 'sports',
    excerpt:
      '落后两分、只剩 0.8 秒、发球被逼到边线。接球、转身、出手，球在灯亮的同时落入网心。多年以后，这球仍会被反复播放。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20basketball%20arena%20art%20with%20warm%20floodlights%20and%20glowing%20orange%20motion%20trails%20arcing%20through%20the%20dark%2C%20energetic%20editorial%20poster%20texture%2C%20crimson%20orange%20and%20amber%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-sports-01&orientation=landscape',
    date: '2026-08-12',
    views: 57830,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['体坛名场面', '压哨绝杀', '篮球'],
    highlights: [
      '落后两分，进攻时间只剩 0.8 秒',
      '边线发球被逼到几乎贴线，接球即出手',
      '球在灯亮瞬间入网，解说当场破音',
    ],
    sections: [
      {
        heading: '几乎不可能完成的进攻',
        text:
          '0.8 秒意味着接球之后几乎没有调整空间。防守方把边线彻底封死，发球球员只能把球抛向一个几乎贴着边线的位置，剩下的交给接球的人自己判断。',
      },
      {
        heading: '接球、转身、出手',
        text:
          '慢镜头回放里，接球的手还没完全稳住，身体已经在向后转了。这不是设计好的战术，而是一个射手在最短时间里做出的最本能的选择。',
      },
      {
        heading: '灯亮与入网几乎同时发生',
        text:
          '现场大屏先是显示灯亮，紧接着球落入网心。全场愣了一瞬才反应过来，解说的声音已经明显破音。这个画面后来被做成了无数个慢放和定格。',
      },
    ],
  },
  {
    id: 'sports-02',
    title: '田径接力赛的惊天逆转：最后一棒是怎么反超的',
    categorySlug: 'sports',
    excerpt:
      '交接棒时还落后近十米，最后一棒却在弯道里一点点追了回来。冲线前那一下，全场都屏住了呼吸。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20track%20and%20field%20stadium%20art%20with%20warm%20evening%20light%20and%20glowing%20motion%20streaks%20on%20a%20curved%20red%20track%2C%20dynamic%20editorial%20poster%20texture%2C%20crimson%20orange%20and%20amber%20palette%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-sports-02&orientation=landscape',
    date: '2026-08-09',
    views: 41870,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['田径', '接力逆转', '弯道超越'],
    highlights: [
      '最后一棒交接时落后近十米',
      '弯道阶段逐步缩小差距',
      '冲线瞬间完成反超，全场屏息',
    ],
    sections: [
      {
        heading: '落后的十米',
        text:
          '接力赛最残酷的地方在于，交接棒的每一秒都会被放大。她们的第三棒结束时，与领先者之间差了将近十米，看上去翻盘希望渺茫。',
      },
      {
        heading: '弯道里一点点追回来',
        text:
          '最后一棒的选手没有选择在直道硬拼，而是把体力分配在了弯道上。每过一个标志点，差距都在以肉眼可见的速度缩小。',
      },
      {
        heading: '冲线前的那一下',
        text:
          '进入最后直道时两人几乎并排。摄像机捕捉到的是她略微前倾的肩膀，就是那一点点提前，决定了最终的名次。',
      },
    ],
  },
  {
    id: 'meme-01',
    title: '今年最出圈的五个表情包，你可能都存过',
    categorySlug: 'meme',
    excerpt:
      '从"我不理解但我大受震撼"到自嘲式的"收到"，每年都会有几个表情包统治聊天框。我们整理了今年传播最广的五个，并说说它们为什么好用。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20stylized%20flat%20illustration%20of%20blank%20rounded%20chat%20bubbles%20and%20sticker%20cards%20in%20warm%20coral%20and%20butter%20yellow%2C%20soft%20graphic%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-meme-01&orientation=landscape',
    date: '2026-09-08',
    views: 68340,
    readTime: '5 分钟',
    author: '看点编辑部',
    tags: ['网络热梗', '表情包', '社交语言'],
    highlights: [
      '五个传播最广的表情包及其使用场景',
      '好用的表情包共同点是"情绪留白"',
      '热梗的生命周期往往取决于能否被二次改写',
    ],
    sections: [
      {
        heading: '为什么表情包比文字更好用',
        text:
          '在聊天里，直接说"我很无语"容易显得严肃，配一张表情包却能把情绪缓冲掉。表情包的价值不在于搞笑，而在于它给对话留了余地。',
      },
      {
        heading: '今年最常被转发的那几个',
        text:
          '从茫然、震惊到自嘲式的认输，今年流行的几个表情包几乎覆盖了日常沟通中最常见的几种情绪。它们的共同点是画面很简单，情绪很模糊，可以随便套用。',
      },
      {
        heading: '热梗为什么会过期',
        text:
          '一个梗能被用多久，很大程度上取决于它能不能被二次改写。能被改编、能套上新语境的梗会活得久，反之很快就会沦为"用力过猛"。',
      },
    ],
  },
  {
    id: 'meme-02',
    title: '从一句话到全网梗：一个热梗是怎么诞生的',
    categorySlug: 'meme',
    excerpt:
      '"前方高能"这四个字，为什么能让无数人会心一笑？我们拆解一个热梗从弹幕到日常用语的完整传播路径。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20art%20of%20glowing%20horizontal%20light%20streaks%20over%20a%20dark%20viewing%20surface%2C%20like%20a%20screen%20glow%20reflected%20in%20darkness%2C%20warm%20amber%20and%20coral%20palette%2C%20minimal%20graphic%20editorial%20poster%20texture%2C%20high%20contrast%2C%20no%20text%2C%20no%20faces&width=1200&height=675&seq=gf-post-meme-02&orientation=landscape',
    date: '2026-08-06',
    views: 33210,
    readTime: '4 分钟',
    author: '看点编辑部',
    tags: ['弹幕文化', '热梗传播', '网络语言'],
    highlights: [
      '"前方高能"从弹幕用语扩散为日常提醒',
      '热梗扩散通常经历提醒、复用、泛化三个阶段',
      '好梗的关键是"一看就懂、一用就对"',
    ],
    sections: [
      {
        heading: '弹幕里的"预警机制"',
        text:
          '"前方高能"最早只是观众之间的互相提醒——下一段有反转或者名场面，提前做好准备。它的作用是管理预期，而不是制造笑点。',
      },
      {
        heading: '三个阶段的扩散',
        text:
          '一个梗的扩散大致会经历三步：先在特定场景里被高频使用，接着被搬进其他语境复用，最后彻底泛化成日常表达。走到第三步，它就从一个圈内黑话变成了公共语言。',
      },
      {
        heading: '为什么它这么耐用',
        text:
          '"前方高能"能被长期使用，是因为它足够中性、随时可用，又不带攻击性。一个梗要想活得久，往往不取决于它多好笑，而取决于它多好用。',
      },
    ],
  },
];

export const faqs = [
  {
    q: '黑料看点是什么类型的网站？',
    a: '黑料看点是一个高能名场面合集门户，专注整理综艺、影视、颁奖礼、体坛和网络热梗方向里最值得回看的精彩片段。我们的目标是让用户点开就能看到事件核心，不拖沓、不注水。',
  },
  {
    q: '网站内容是免费观看的吗？',
    a: '是的。所有合集内容和看点整理都可以免费浏览，无需注册或付费。我们靠内容质量而不是会员墙来留住读者。',
  },
  {
    q: '内容多久更新一次？',
    a: '编辑部通常每周固定更新两到三次合集，遇到大型赛事或颁奖礼等热点，会临时加更专题盘点，保证用户第一时间看到高光片段。',
  },
  {
    q: '你们如何判断一个片段是否"高能"？',
    a: '我们更看重片段本身的情绪浓度和信息密度：是否有明确的转折、是否有值得回味的细节、是否能在最短时间内交代清楚前因后果。时长从来不是标准。',
  },
  {
    q: '可以投稿或推荐名场面吗？',
    a: '当然可以。你可以通过联系我们页面的留言表单提交推荐，注明节目名称、大致时间点和推荐理由。编辑团队会逐条查看，合适的会优先安排进合集。',
  },
  {
    q: '发现内容有误怎么办？',
    a: '欢迎通过留言表单反馈，附上页面标题和具体问题。我们核实后会在第一时间修改，并在页面更新记录中说明调整内容。',
  },
];

export const testimonials = [
  {
    name: '泡芙不加糖',
    role: '追剧常驻',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20minimal%20abstract%20circular%20gradient%20avatar%20in%20warm%20coral%20and%20cream%20tones%2C%20gentle%20texture%2C%20no%20text%2C%20no%20faces&width=120&height=120&seq=gf-avatar-01&orientation=squarish',
    text: '最省时间的一个站，别的平台要拉进度条，这里直接给到高能片段和背景交代，通勤路上看两条刚好。',
  },
  {
    name: '阿远看球',
    role: '体育爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20minimal%20abstract%20circular%20gradient%20avatar%20in%20warm%20amber%20and%20deep%20brown%20tones%2C%20gentle%20texture%2C%20no%20text%2C%20no%20faces&width=120&height=120&seq=gf-avatar-02&orientation=squarish',
    text: '压哨绝杀那期整理得特别清楚，把战术和 0.8 秒的时间逻辑都讲明白了，不是单纯剪个片段糊弄人。',
  },
  {
    name: '橘子汽水',
    role: '表情包收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20minimal%20abstract%20circular%20gradient%20avatar%20in%20warm%20orange%20and%20butter%20yellow%20tones%2C%20gentle%20texture%2C%20no%20text%2C%20no%20faces&width=120&height=120&seq=gf-avatar-03&orientation=squarish',
    text: '热梗栏目真的好用，看完知道自己天天发的表情包是从哪来的，聊天都更有底气了。',
  },
];